"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var qs_1 = __importDefault(require("qs"));

var join = require("url-join");

function generate(paths, query) {
  var url = join(paths);

  if (query) {
    url = url + "?" + qs_1.default.stringify(query);
  }

  return url;
}

exports.urlUtils = {
  join: join,
  generate: generate
};